<template>
    <v-container pt-2>
        <v-layout column>
            <a-date-field 
               xs12 label="Período entre" v-model="filterData.dateRange[0]" 
               validate="dateDMY" dateFormat="DD/MM/YYYY" clearable
            ></a-date-field>
            <a-date-field 
               xs12 label="e" v-model="filterData.dateRange[1]" 
               validate="dateDMY" dateFormat="DD/MM/YYYY" clearable
            ></a-date-field>

            <a-select-field 
               label="Totalizar por" :suggestions="sumTypes"
               v-model="filterData.sumType"
            ></a-select-field>

            <v-checkbox 
               v-if="isMaster"
               label="Apenas meus leads" 
               v-model="filterData.myLeads"
            ></v-checkbox>

            <a-select-field box class="clean-style"
               label="Apenas referente ao Afiliado"
               obj="affiliate"
               v-model="filterData.affiliateId"
               ref="affiliateField"
               v-if="isMaster"
               clearable
            ></a-select-field>

            <a-select-field 
               clearable label="Apenas referente ao produto" 
               obj="productType" sm4 v-model="filterData.productId"
            ></a-select-field>

            <a-select-field 
               clearable label="Por campanha" 
               :suggestions="campaigns" ref="campaignField"
               sm4 v-model="filterData.campaignId"
            ></a-select-field>
        </v-layout>
    </v-container>
</template>

<script>

   export default {
      props: {
         reloadKey: {
            type: Number,
            required: false
         },
         execute: {
            type: Boolean,
            required: false,
            default: false
         }
      },

      data: () => ({
         banks: [],
         products: [],
         campaigns: [],

         filterData: {
            affiliateId: null,
            myLeads: false,
            productId: null,
            sumType: 'daily',
            dateRange: [null, null],
            campaignId: null
         },

         sumTypes: [
            {id: 'daily', name: 'Dia'},
            {id: 'weekly', name: 'Semana'},
            {id: 'monthly', name: 'Mês'},
            {id: 'yearly', name: 'Ano'}
         ]
      }),

      watch: {
         reloadKey: {
            immediate: true,
            handler: function () {
               this.$nextTick(() => this.reloadFilters());
            }
         },
         execute(val) {
            val && this.applyFilter();
         }
      },

      computed: {
         isMaster() {
            return this.$uCan({key: 'subAfiliados'}) === 1;
         },
      },

      methods: {
         applyFilter() {
            let filters = [];

            let rangeLabel = '';
            if (this.filterData.dateRange) {
               let dateRange = this.filterData.dateRange.filter(d => d !== null);
               dateRange.forEach((v, i) => dateRange[i] = this.$moment(v).format('YYYY-MM-DD'));

               if (dateRange.length === 2)
                  rangeLabel += (dateRange[0] === dateRange[1]) ? 'Em ' + this.$moment(dateRange[0]).format('DD/MM/YYYY') : 'Entre {0} e {1}'.format(this.$moment(dateRange[0]).format('DD/MM/YYYY'), this.$moment(dateRange[1]).format('DD/MM/YYYY'))
               else if (dateRange.length)
                  rangeLabel += 'Em ' + this.$moment(dateRange[0]).format('DD/MM/YYYY');
               else
                  rangeLabel = '';

               if (!rangeLabel) {
                  this.filterData.dateRange = [null, null];
               }
            }

            let productName;
            this.filterData.productId ? productName = this.products.find(el => el.id == this.filterData.productId).name : productName = null;
            filters.push({field: 'productId', value: this.filterData.productId, label: productName ? productName : null});

            let affiliateName;
            if(this.filterData.affiliateId  && this.$refs.affiliateField && this.$refs.affiliateField.items.length){
               let auxText = this.$refs.affiliateField.items.find(el => el.id == this.filterData.affiliateId);
               affiliateName = auxText && auxText.name ? auxText.name : null
            }
            filters.push({field: 'myLeads', value: this.filterData.myLeads, label: this.filterData.myLeads ? 'Apenas meus leads' : '' });
            filters.push({field: 'affiliateId', value: this.filterData.affiliateId, label: affiliateName});

            let campaignName;
            if(this.filterData.campaignId  && this.$refs.campaignField && this.$refs.campaignField.items.length){
               let auxText = this.$refs.campaignField.items.find(el => el.id == this.filterData.campaignId);
               campaignName = auxText && auxText.name ? auxText.name : null
            }
            filters.push({field: 'campaignId', value: this.filterData.campaignId, label: campaignName});
            
            let typeLabel = this.sumTypes.filter(t => t.id === this.filterData.sumType)[0].name;
            filters.push({field: 'sumType', value: this.filterData.sumType, label: 'Totalizado por ' + typeLabel});
            filters.push({field: 'dateRange', value: this.filterData.dateRange, label: rangeLabel});

            this.$store.dispatch('updateAllPageFilters', filters);
            setTimeout(() => this.$emit('close'), 150);
         },

         reloadFilters() {
            let currentFilters = this.$store.getters.activePageFilters;

            this.$util.updateObj(this.filterData, currentFilters);
            if (!this.filterData.dateRange) {
               this.filterData.dateRange = [null, null];
            }
         }
      },
      async created() {
         this.banks = await this.$api.dataService.search('bank');
         this.products = await this.$api.dataService.search('productType');
         this.campaigns = await this.$api.dataService.execute('campaign/getMyBrandLinks', {});
      }
   }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/DashboardFilter.vue